/*
 * @Author: cc
 * @LastEditTime: 2025-07-10 10:43:57
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-05-27 13:40:25
 */
import React, { useEffect } from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import Index from "../page/index";
import Play from "../page/play/play";
import SignupFloat from "../page/component/signupFloat";
export const routes = [
  {
    path: "/index",
    component: Index,
  },
  {
    path: "/play",
    component: Play,
  },
  {
    path: "*",
    component: Index,
  },
];
function RouteWithSubRoutes(route) {
  useEffect(() => {
  }, []);
  return (
    <>
      <Route
        path={route.path}
        render={(props) => (
          <>
            <route.component {...props} routes={route.routes} />
          </>
        )}
      />
    </>
  );
}
let RouteConfigExample = (props) => {
  return (
    <HashRouter>
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={i} {...route} />
        ))}
      </Switch>
      <SignupFloat />
    </HashRouter>
  );
};
export default RouteConfigExample;
